import React, { useState } from 'react'
import { useLanguage } from '~components'
import { Alert } from '../Confirm'
import activityIcon from '../../../../assets/images/newimage/activity.svg'
import shareIcon from '../../../../assets/images/newimage/share.svg'
import helpIcon from '../../../../assets/images/newimage/help.svg'

import {
  PageContainer,
  TopSection,
  PageTitle,
  TopGrid,
  LeftCol,
  LeftSubtitle,
  PinkBtn,
  BlueBtn,
  CardsRow,
  ServiceCard,
  ServiceCardTitle,
  ServiceCardText,
  FormSection,
  FormSectionTitle,
  FormGrid,
  FormRow,
  FormInput,
  FormTextarea,
  FormFooter,
  FormNote,
  SendBtn,
  SupportSection,
  SupportTitle,
  YellowBanner,
  BannerTitle,
  BannerSubtitle,
  BottomBar,
  BottomText,
  BottomBtn
} from './styles'

/* ─── Service card icons ─── */
// Inline SVGs removed and replaced by imported assets

/* ─── Main component ─── */
export const ContactBottleRunners = () => {
  const [, t] = useLanguage()
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    alternatePhone: '',
    address: '',
    zipCode: '',
    city: '',
    stateProvince: '',
    subject: '',
    message: '',
    orderSupport: ''
  })
  const [alertState, setAlertState] = useState({ open: false, content: [] })

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!form.fullName || !form.email || !form.message) {
      setAlertState({
        open: true,
        content: [t('REQUIRED_FIELDS_MISSING', 'Please fill in all required fields (Name, Email, Message)')]
      })
      return
    }

    setLoading(true)
    try {
      // Update this URL to your actual backend API URL
      const response = await fetch('https://plugins-development.ordering.co/bottlerunners/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(form)
      })

      const result = await response.json()

      if (response.ok) {
        setAlertState({
          open: true,
          content: [result.message || t('MESSAGE_SENT_SUCCESS', 'Message sent successfully!')]
        })
        setForm({
          fullName: '',
          email: '',
          phone: '',
          alternatePhone: '',
          address: '',
          zipCode: '',
          city: '',
          stateProvince: '',
          subject: '',
          message: '',
          orderSupport: ''
        })
      } else {
        setAlertState({
          open: true,
          content: [result.message || t('ERROR_SENDING_MESSAGE', 'Failed to send message.')]
        })
      }
    } catch (error) {
      console.error('API Error:', error)
      setAlertState({
        open: true,
        content: [t('CONNECTION_ERROR', 'Could not connect to the server.')]
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <PageContainer>

      {/* ─── Top Section ─── */}
      <TopSection>
        <PageTitle>{t('CONTACT_BOTTLE_RUNNERS', 'CONTACT BOTTLE RUNNERS')}</PageTitle>

        <TopGrid>
          {/* Left CTA */}
          <LeftCol>
            <LeftSubtitle>{t('WE_ARE_HERE', "We're here when the right ist on")}</LeftSubtitle>
            <PinkBtn onClick={() => { window.location.href = 'tel:+14372688537' }}>
              {t('DIAL_A_BOTTLE', 'DIAL A BOTTLE')}
            </PinkBtn>
            <BlueBtn onClick={() => { window.location.href = 'https://wa.me/14372688537' }}>
              {t('TEXT_US', 'TEXT US')} &nbsp;→
            </BlueBtn>
          </LeftCol>

          {/* Right — 3 Service Cards */}
          <CardsRow>
            <ServiceCard>
              <ServiceCardTitle>{t('ORDER_SUPPORT', 'Order Support')}</ServiceCardTitle>
              <img src={helpIcon} alt='Order Support' />
              <ServiceCardText>
                {t('ORDER_SUPPORT_TEXT', 'For active arciers or Imint elisttame.')}
              </ServiceCardText>
            </ServiceCard>
            <ServiceCard>
              <ServiceCardTitle>{t('AFFILIATE_INQUIRIES', 'Affiliate Inquiries')}</ServiceCardTitle>
              <img src={shareIcon} alt='Affiliate Inquiries' />
              <ServiceCardText>
                {t('AFFILIATE_TEXT', 'Intermisted in operaling eulen ovan terrifany?')}
              </ServiceCardText>
            </ServiceCard>
            <ServiceCard>
              <ServiceCardTitle>{t('RUNNER_APPLICATIONS', 'Runner Applications')}</ServiceCardTitle>
              <img src={activityIcon} alt='Runner Applications' />
              <ServiceCardText>
                {t('RUNNER_TEXT', 'Apply to became Runners runner')}
              </ServiceCardText>
            </ServiceCard>
          </CardsRow>
        </TopGrid>
      </TopSection>

      {/* ─── Contact Form ─── */}
      <FormSection>
        <FormSectionTitle>{t('CONTACT_FORM', 'Contact Form')}</FormSectionTitle>
        <form onSubmit={handleSubmit}>
          <FormGrid>
            <FormRow>
              <FormInput name='fullName' value={form.fullName} onChange={handleChange} placeholder={t('FULL_NAME', 'Full Name *')} required />
              <FormInput name='email' value={form.email} onChange={handleChange} placeholder={t('EMAIL_ADDRESS', 'Email Address *')} type='email' required />
              <FormInput name='phone' value={form.phone} onChange={handleChange} placeholder={t('PHONE_NUMBER', 'Phone Number')} type='tel' />
            </FormRow>
            <FormRow>
              <FormInput name='alternatePhone' value={form.alternatePhone} onChange={handleChange} placeholder={t('ALTERNATE_PHONE', 'Alternate Phone')} type='tel' />
              <FormInput name='address' value={form.address} onChange={handleChange} placeholder={t('ADDRESS', 'Street Address')} />
              <FormInput name='zipCode' value={form.zipCode} onChange={handleChange} placeholder={t('ZIP_CODE', 'Zip / Postal Code')} />
            </FormRow>
            <FormRow>
              <FormInput name='city' value={form.city} onChange={handleChange} placeholder={t('CITY', 'City')} />
              <FormInput name='stateProvince' value={form.stateProvince} onChange={handleChange} placeholder={t('STATE_PROVINCE', 'State / Province')} />
              <FormInput name='subject' value={form.subject} onChange={handleChange} placeholder={t('SUBJECT', 'Subject')} />
            </FormRow>
            <FormRow>
              <FormTextarea name='message' value={form.message} onChange={handleChange} placeholder={t('MESSAGE', 'Message *')} required />
              <FormTextarea name='orderSupport' value={form.orderSupport} onChange={handleChange} placeholder={t('ORDER_SUPPORT_REASON', 'Order Support Reason')} />
            </FormRow>
          </FormGrid>

          <FormFooter>
            <FormNote>
              {t('TEAM_RESPONSE', 'Our team will respond to as as 1 bo pesable.')}
            </FormNote>
            <SendBtn type='submit' disabled={loading}>
              {loading ? t('SENDING', 'SENDING...') : t('SEND_MESSAGE', 'SEND MESSAGE')}
            </SendBtn>
          </FormFooter>
        </form>
      </FormSection>

      {/* ─── Support Options ─── */}
      <SupportSection>
        <SupportTitle>{t('SUPPORT_OPTIONS', 'Suppact Options')}</SupportTitle>
        <YellowBanner>
          <BannerTitle>
            {t('BOTTLE_RUNNERS_REBOOT', 'Bottle Runners | Reboot the Night.')}
          </BannerTitle>
          <BannerSubtitle>
            {t('FAST_SUPPORT', 'Fast support when you need it')}
          </BannerSubtitle>
        </YellowBanner>
      </SupportSection>

      {/* ─── Sticky Bottom Bar ─── */}
      <BottomBar>
        <BottomText>{t('PLACE_ORDER_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn onClick={() => { window.location.href = t('CALL_NOW_LINK', 'tel:+1234567890') }}>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>

      <Alert
        title={t('CONTACT_BOTTLE_RUNNERS', 'Contact Bottle Runners')}
        content={alertState.content}
        acceptText={t('ACCEPT', 'Accept')}
        open={alertState.open}
        onClose={() => setAlertState({ open: false, content: [] })}
        onAccept={() => setAlertState({ open: false, content: [] })}
        closeOnBackdrop={false}
      />

    </PageContainer>
  )
}

export default ContactBottleRunners
